/* Ansichtswechsel Raster / Liste (Produktkachel-v3-Handoff §10, §11).

   Der Zustand liegt in localStorage, damit er die Sitzung ueberlebt — eine
   URL-Variante wuerde jeden geteilten Link mit einer Ansichtsvorgabe
   belasten, die der Empfaenger nicht gewaehlt hat.

   Vanilla Custom Element, kein Framework, `defer` geladen. */
class RcViewToggle extends HTMLElement {
  static SCHLUESSEL = 'rc-collection-view';

  connectedCallback() {
    this.raster = document.querySelector('[data-product-grid]') ||
                  document.querySelector('.rc-collection__grid');
    if (!this.raster) return;

    this.knoepfe = Array.from(this.querySelectorAll('[data-view]'));
    if (!this.knoepfe.length) return;

    let ansicht;
    try {
      ansicht = localStorage.getItem(RcViewToggle.SCHLUESSEL);
    } catch (e) {
      /* Privater Modus verbietet den Zugriff — dann gilt die Voreinstellung. */
      ansicht = null;
    }
    this.setzen(ansicht || this.dataset.default || 'grid', false);

    this.knoepfe.forEach((k) =>
      k.addEventListener('click', () => this.setzen(k.dataset.view, true))
    );
  }

  setzen(ansicht, merken) {
    const liste = ansicht === 'list';
    this.raster.classList.toggle('rc-collection__grid--liste', liste);
    this.knoepfe.forEach((k) =>
      k.setAttribute('aria-pressed', String(k.dataset.view === ansicht))
    );
    if (!merken) return;
    try {
      localStorage.setItem(RcViewToggle.SCHLUESSEL, ansicht);
    } catch (e) {
      /* Nicht speicherbar ist kein Grund, die Ansicht nicht zu wechseln. */
    }
  }
}

if (!customElements.get('rc-view-toggle')) {
  customElements.define('rc-view-toggle', RcViewToggle);
}
